export const PANEL_ENVS = {
  CPF: 'cpf',
  CNPJ: 'cnpj',
}
